import { useState } from "react";
import { useNavigate } from "react-router-dom";

const CANCEL_REASONS = [
  "临时有事，去不了了",
  "地址填错了",
  "未联系上足疗师",
  "足疗师未按时服务",
  "其他",
];

export default function CancelReasonPage() {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <div
        className="flex flex-col min-h-screen items-center justify-center"
        style={{ background: "#F4F4F6", maxWidth: 480, margin: "0 auto" }}
      >
        <div className="flex flex-col items-center px-8">
          <div
            className="w-16 h-16 flex items-center justify-center rounded-full mb-4"
            style={{ background: "#F0F0F0" }}
          >
            <i className="ri-close-circle-line text-3xl" style={{ color: "#AAAAAA" }} />
          </div>
          <p className="text-base font-bold mb-1" style={{ color: "#1A1A1A" }}>订单已取消</p>
          <p className="text-sm mb-2 text-center" style={{ color: "#AAAAAA" }}>退款将在 1-3 个工作日内原路返回</p>
          <p className="text-xs mb-8 text-center" style={{ color: "#CCCCCC" }}>取消原因：{selected}</p>
          <button
            onClick={() => navigate("/orders")}
            className="w-full py-3.5 rounded-full text-white font-bold text-sm cursor-pointer whitespace-nowrap"
            style={{ background: "linear-gradient(90deg, #FF8C3A, #FF5C00)" }}
          >
            返回订单列表
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col min-h-screen"
      style={{ background: "#F4F4F6", maxWidth: 480, margin: "0 auto" }}
    >
      {/* Header */}
      <div className="bg-white flex items-center gap-3 px-4 pt-4 pb-3 sticky top-0 z-40" style={{ borderBottom: "1px solid #F2F2F2" }}>
        <button onClick={() => window.history.length > 1 ? navigate(-1) : navigate("/")} className="w-8 h-8 flex items-center justify-center cursor-pointer">
          <i className="ri-arrow-left-line text-xl" style={{ color: "#1A1A1A" }} />
        </button>
        <h1 className="text-base font-bold flex-1 text-center" style={{ color: "#1A1A1A" }}>取消原因</h1>
        <div className="w-8" />
      </div>

      <div className="flex-1 px-4 pt-5 pb-28">
        <p className="text-sm font-semibold mb-4" style={{ color: "#1A1A1A" }}>请选择</p>

        {/* Reason list */}
        <div className="bg-white rounded-2xl overflow-hidden mb-4" style={{ border: "1px solid #F0F0F0" }}>
          {CANCEL_REASONS.map((reason, idx) => (
            <button
              key={reason}
              onClick={() => setSelected(reason)}
              className="w-full flex items-center gap-3 px-4 py-4 cursor-pointer"
              style={{
                borderBottom: idx < CANCEL_REASONS.length - 1 ? "1px solid #F8F8F8" : "none",
                background: selected === reason ? "#FFF8F5" : "#fff",
              }}
            >
              {/* Radio */}
              <div
                className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
                style={{
                  border: selected === reason ? "none" : "1.5px solid #DDDDDD",
                  background: selected === reason ? "#FF5C00" : "transparent",
                }}
              >
                {selected === reason && (
                  <div className="w-2 h-2 rounded-full bg-white" />
                )}
              </div>
              <span className="text-sm" style={{ color: "#1A1A1A" }}>{reason}</span>
            </button>
          ))}
        </div>

        {/* Tips */}
        <div className="rounded-2xl px-4 py-4" style={{ background: "#FFF8F0", border: "1px solid #FFE8CC" }}>
          <p className="text-sm font-semibold mb-2" style={{ color: "#FF7B22" }}>温馨提示</p>
          <p className="text-xs leading-relaxed" style={{ color: "#AAAAAA" }}>
            取消订单后，已支付金额将按照平台规则退还。若技师已出发，可能会产生一定的违约费用。请确认后再提交取消申请，感谢您的理解与配合，我们致力于为您提供最优质的上门服务体验。
          </p>
        </div>
      </div>

      {/* Bottom */}
      <div
        className="fixed bottom-0 px-4 py-4 bg-white w-full"
        style={{ maxWidth: 480, left: "50%", transform: "translateX(-50%)", borderTop: "1px solid #F0F0F0" }}
      >
        <button
          onClick={() => { if (selected) setSubmitted(true); }}
          disabled={!selected}
          className="w-full py-3.5 rounded-full text-white font-bold text-sm cursor-pointer whitespace-nowrap transition-opacity"
          style={{ background: selected ? "linear-gradient(90deg, #FF8C3A, #FF5C00)" : "#E0E0E0" }}
        >
          提交
        </button>
      </div>
    </div>
  );
}
